import { valueWritable } from "./store";

export const mouse = valueWritable({ clientX: 0, clientY: 0 });

function updateMouse(e: MouseEvent) {
    mouse.set({ clientX: e.clientX, clientY: e.clientY });
}


window.addEventListener("mousemove", updateMouse);
